/* eslint-disable import/prefer-default-export */
import { getEncodedParams } from 'helpers/encodeParams';

export const realValueEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/realvalue/attribution-summary?start=${encodedParams.start}&end=${encodedParams.end}`;
};



// WEBPACK FOOTER //
// ./src/services/realValue/selectors.js